var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptySearchDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 350,
    viewBox: "0 0 350 350",
    width: 350,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m114.673 156.95c17.484 5.469 34.022 25.867 40.134 35.421.016.025.015.055 0 .08-.045.078.057.161.124.1 5.577-5.055 12.545-8.263 20.103-8.263 7.713 0 14.811 3.34 20.443 8.574.208.193.561-.08.417-.325-.046-.078-.047-.171.002-.247 6.153-9.588 22.647-29.886 40.082-35.34 13.303-4.162 28.617-3.758 38.852-2.49 3.993.495 5.92 4.85 3.633 8.161-6.833 9.897-18.323 23.279-30.494 27.932-10.54 4.03-24.945 6.093-36.125 7.028-4.854.406-7.769 6.246-6.073 10.812 1.558 4.192 2.416 8.624 2.416 13.026 0 1.409-.112 2.774-.326 4.094-.348 2.144.166 4.365 1.444 6.122 2.549 3.504 3.982 7.369 3.982 11.308 0 13.615-21.889 22.952-38.253 22.952s-38.253-9.337-38.253-22.952c0-3.939 1.433-7.804 3.982-11.309 1.278-1.757 1.792-3.978 1.445-6.122-.214-1.319-.326-2.684-.326-4.093 0-4.426.867-8.882 2.441-13.095 1.701-4.553-1.188-10.371-6.03-10.787-11.105-.955-25.231-3.016-35.611-6.984-12.1709-4.653-23.6605-18.035-30.4942-27.932-2.2866-3.311-.3601-7.666 3.6338-8.161 10.2344-1.268 25.5494-1.672 38.8514 2.49z",
    fill: "#1e2129",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#d2d8df",
    strokeWidth: 0.782823
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.87695 160.56v2.844",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.49219 162.101 2.32387 2.392",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.772461 168.469h3.285919",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.22461 174.951 2.32387-2.392",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.87695 175.727v-2.844",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.6166 173.831-1.8959-1.896",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.4093 169.091h-2.8439",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.5141 162.455-1.8959 1.896",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.5 36.376v1.8959",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.813 42.0637h1.896",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.5 47.7519v-1.8959",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.242 42.0637h-1.896",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.5352 116.004v2.844",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.0059 124.537h2.8439",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.5352 132.121v-2.844",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.1203 124.537h-2.8439",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.589 219.372c2.266 0 4.103 1.837 4.103 4.103 0 2.267-1.837 4.104-4.103 4.104-2.265 0-4.103-1.837-4.103-4.104",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.316 273.319c.507 3.539-1.949 6.819-5.486 7.326-3.538.506-6.816-1.951-7.323-5.489s1.949-6.817 5.486-7.324",
    strokeLinecap: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m275.366 182.139c2.436-.759 6.17-3.739 7.035-6.944.784 2.833 4.07 6.185 7.034 6.438-3.337 1.182-6.528 4.692-7.034 7.45-.345-2.811-4.758-6.534-7.035-6.944",
    fill: "#ebecee",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m25.3027 218.107c1.2185-.38 3.0848-1.869 3.5169-3.472.392 1.416 2.0345 3.092 3.5169 3.219-1.6683.59-3.2634 2.346-3.5169 3.725-.1722-1.406-2.3789-3.268-3.5169-3.472",
    fill: "#ebecee",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m47.9144 86.2376c0 1.7581-1.4245 3.1821-3.1813 3.1821-1.7577 0-3.1813-1.424-3.1813-3.1821 0-1.7573 1.4236-3.1822 3.1813-3.1822 1.7568 0 3.1813 1.4249 3.1813 3.1822",
    fill: "#d1d8df",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m235.782 286.031c0 2.937-2.382 5.319-5.318 5.319-2.937 0-5.318-2.382-5.318-5.319s2.381-5.319 5.318-5.319c2.936 0 5.318 2.382 5.318 5.319",
    fill: "#ebecee",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m334 80.3718c0 2.3305-1.888 4.219-4.217 4.219-2.33 0-4.218-1.8885-4.218-4.219s1.888-4.219 4.218-4.219c2.329 0 4.217 1.8885 4.217 4.219",
    fill: "#ebecee",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m107.369 277.413c0 1.469-1.19 2.66-2.659 2.66-1.468 0-2.658-1.191-2.658-2.66s1.19-2.66 2.658-2.66c1.469 0 2.659 1.191 2.659 2.66z",
    fillRule: "evenodd",
    stroke: "#d2d8df",
    strokeLinecap: "round",
    strokeWidth: 0.782823
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m105.788 65.7937c0 1.7581-1.424 3.1821-3.181 3.1821s-3.1812-1.424-3.1812-3.1821c0-1.7573 1.4242-3.1821 3.1812-3.1821s3.181 1.4248 3.181 3.1821z",
    fillRule: "evenodd",
    stroke: "#d2d8df",
    strokeLinecap: "round",
    strokeWidth: 0.782823
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m186.936 306.866c-2.033.773-4.308-.248-5.082-2.281-.773-2.033.247-4.31 2.281-5.083 2.032-.773 4.307.247 5.081 2.281.774 2.033-.248 4.309-2.28 5.083z",
    fillRule: "evenodd",
    stroke: "#d2d8df",
    strokeLinecap: "round",
    strokeWidth: 0.782823
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.333,
    cy: 212.34,
    fill: "#000",
    rx: 2.55021,
    ry: 4.25035
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.437,
    cy: 212.34,
    fill: "#000",
    rx: 2.55021,
    ry: 4.25035
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m176.396 245.621c1.364-.407 4.236-1.42 5.956-3.153 1.322-1.333-.137-3.007-2.015-3.007h-9.411c-1.878 0-3.337 1.674-2.015 3.007 1.72 1.733 4.592 2.746 5.956 3.153.5.149 1.029.149 1.529 0z",
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2.55021
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m175.885 245.493c0 7.512-3.805 13.601-8.5 13.601",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2.55021
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m184.386 259.094c-4.694 0-8.5-6.089-8.5-13.601",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2.55021
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m217.864 156.86c-16.756 8.97-22.708 25.347-23.589 32.414-4.474 6.727-15.658-3.262-13.625-6.728 2.034-3.465 4.271-9.377 5.694-14.27 1.424-4.893-.203-9.582-5.694-15.901-5.49-6.32-2.44-15.698-2.033-20.794.406-5.097 8.134-9.378 4.88-1.223-3.254 8.154 2.847 13.251 5.491 17.124 2.115 3.099 8.202 6.727 10.981 8.154 2.034-1.359 6.792-5.137 9.558-9.377 3.457-5.301 5.084-9.582-3.457-23.037s-7.118-18.551-6.101-21.405c1.017-2.8543 4.067-1.631 3.66 1.223-.406 2.854 8.135 13.455 14.235 20.182 4.881 5.382 6.643 12.98 6.914 16.105 1.085-.543 4.271-1.834 8.338-2.65 17.489-5.3 18.912-28.133 20.132-33.637 1.22-5.5043-5.084-15.9013 0-12.8433 5.084 3.0579 7.931 22.8323 5.491 33.0253s-10.575 16.309-10.575 17.736 10.372 6.116 0 5.301c-10.371-.816-9.354-.612-30.3 10.601z",
    fill: "#11141a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m130.58 156.86c16.757 8.97 22.708 25.347 23.589 32.414 4.474 6.727 15.659-3.262 13.625-6.728-2.033-3.465-4.27-9.377-5.694-14.27-1.423-4.893.204-9.582 5.694-15.901 5.491-6.32 2.44-15.698 2.034-20.794-.407-5.097-8.134-9.378-4.881-1.223 3.254 8.154-2.847 13.251-5.49 17.124-2.115 3.099-8.202 6.727-10.982 8.154-2.033-1.359-6.792-5.137-9.557-9.377-3.457-5.301-5.084-9.582 3.457-23.037s7.117-18.551 6.1-21.405c-1.016-2.8543-4.067-1.631-3.66 1.223s-8.134 13.455-14.235 20.182c-4.881 5.382-6.643 12.98-6.914 16.105-1.085-.543-4.271-1.834-8.338-2.65-17.4883-5.3-18.9118-28.133-20.132-33.637-1.2201-5.5043 5.084-15.9013 0-12.8433-5.0839 3.0579-7.9309 22.8323-5.4906 33.0253s10.5746 16.309 10.5746 17.736-10.3712 6.116 0 5.301c10.371-.816 9.354-.612 30.3 10.601z",
    fill: "#11141a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearchDark);
export default __webpack_public_path__ + "static/media/EmptySearchDark.bcaa29b753b0e8a14e76c0effaec79a7.svg";
export { ForwardRef as ReactComponent };